import React from 'react';
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Category,
  BarSeries,
  Legend,
  Tooltip
} from '@syncfusion/ej2-react-charts';

import "../Tables/Customs/syncfusion-grid-overrides.css";
import "@syncfusion/ej2-base/styles/bootstrap5.css";
import "@syncfusion/ej2-buttons/styles/bootstrap5.css";
import "@syncfusion/ej2-inputs/styles/bootstrap5.css";
import "@syncfusion/ej2-navigations/styles/bootstrap5.css";
import "@syncfusion/ej2-popups/styles/bootstrap5.css";
import "@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
import "@syncfusion/ej2-dropdowns/styles/bootstrap5.css";
import "@syncfusion/ej2-grids/styles/bootstrap5.css";
import "../../../styles/chartResponsive.css";
import { useTheme } from '../../../contexts/ThemeContext';

export const ChartColumnsVertical = (props) => {
  const { isDark } = useTheme();

  return (
    <div className="chart-container chart-columns-container">
      <ChartComponent
        id={props.id}
        height={"100%"}
        width={"100%"}
        chartArea={{ border: { width: 0 } }}
        margin={{ left: 0, right: 0, top: 0, bottom: 40 }}
        primaryXAxis={{
          valueType: "Category",
          majorGridLines: { width: 0 },
          labelStyle: { color: isDark ? "#FFF" : "#000" }
        }}
        primaryYAxis={{
          opposedPosition: true, // 👈 joga os rótulos das categorias pro lado direito
          majorGridLines: { width: 0 },
          labelStyle: { color: isDark ? "#FFF" : "#000" }
        }}
        legendSettings={{
          visible: true,
          textStyle: { color: props.color, size: "14px", fontWeight: "500" }
        }}
        tooltip={{ enable: true, format: "${point.x} : ${point.y}" }}
        style={{ width: "100%", height: "100%", minHeight: "300px", color: "#FFF" }}
      >
        <Inject services={[BarSeries, Category, Tooltip, Legend]} />
        <SeriesCollectionDirective>
          <SeriesDirective
            dataSource={props.data}
            xName={props.xName}
            yName={props.yName}
            type="Bar"  // 👈 barras horizontais
            pointColorMapping={props.color}
            legendShape="Rectangle"
          />
        </SeriesCollectionDirective>
      </ChartComponent>
    </div>
  );
};
